/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FormatInputs */



/**
* | output |
* | --- |
* | "Format" |
*
* @param {FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const format = /** @type {((inputs?: FormatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FormatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format")
	if (locale === "de") return /** @type {LocalizedString} */ ("Format")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Формат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("形式")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारूप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatar")
	return /** @type {LocalizedString} */ ("Format")
});